import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { Application } from 'src/app/shared/models/Application.model';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-expandable-list',
  templateUrl: './expandable-list.component.html',
  styleUrls: ['./expandable-list.component.css'],
})
export class ExpandableListComponent implements OnInit {
  @Input() applications: Application[];
  @Input() filterby: any;

  detailedInfoForm: FormGroup;
  unsortedObjects = [];
  page = 1;
  pageSize = 30;
  sortedCol = [];
  updatedApp;

  constructor(private applicationService: ApplicationService) {}

  ngOnInit(): void {
    this.unsortedObjects = this.unsortedObjects.concat(this.applications);
    this.getFilteredApplications();
  }

  getFilteredApplications() {
    if (this.filterby) {
      this.applications = this.applications.filter(
        (application) => application[this.filterby.name] == this.filterby.value
      );
    }
  }

  onSortCol(obj: string): void {
    if (this.sortedCol[0] !== obj) {
      this.sortedCol = ['', 0, ''];
    }
    if (this.sortedCol[0] === '' && this.sortedCol[1] === 0) {
      this.applications = this.applications.sort((n1, n2) => {
        if (n1[obj] > n2[obj]) {
          return 1;
        }
        if (n1[obj] < n2[obj]) {
          return -1;
        }
        return 0;
      });
      this.sortedCol = [obj, 1, 'bi bi-arrow-down'];
    } else if (this.sortedCol[0] === obj && this.sortedCol[1] === 1) {
      this.applications = this.applications.sort((n1, n2) => {
        if (n1[obj] > n2[obj]) {
          return -1;
        }
        if (n1[obj] < n2[obj]) {
          return 1;
        }
        return 0;
      });
      this.sortedCol[1] = -1;
      this.sortedCol[2] = 'bi bi-arrow-up';
    } else {
      this.applications = this.applications.splice(
        0,
        this.applications.length,
        ...this.unsortedObjects
      );
      this.sortedCol = ['', 0];
    }
  }

  onSubmit(evt) {
    this.applicationService.updateApplication(evt);
    this.updateNotification();
  }

  updateNotification() {
    this.updatedApp = true;
    setTimeout(() => (this.updatedApp = false), 2000);
  }
}
